import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {AuthService} from '../../../../core/auth/auth.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;

  constructor(private authService: AuthService,
              private router: Router,
              private toastr: ToastrService) { }

  ngOnInit(): void {
    this.initFormGroupControls();
  }

  private initFormGroupControls(): void {
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  resetPassword(): void {
    if (this.isFormValid(this.forgotPasswordForm)) {
      this.authService.forgotPassword(this.forgotPasswordForm.value)
        .then(() => {
          this.router.navigate(['/login']);
        })
        .catch((error) => {
          this.toastr.error(error.message, 'Error!');
        });
    }
  }

  private isFormValid(formGroup: FormGroup): boolean {
    return formGroup.valid;
  }
}
